var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-menu-user",
    transform: "translate(-28.332 -1051.639)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 36,
    height: 36,
    transform: "translate(28.332 1051.639)",
    fill: "#fff",
    opacity: 0.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5408\\u4F53_3",
    "data-name": "\\u5408\\u4F53 3",
    d: "M9.431,22.646H2.17c-1.92,0-2.791-2.793-1.681-4.767a9.355,9.355,0,0,1,4.44-4.132,7.845,7.845,0,0,0,9,0,9.357,9.357,0,0,1,4.441,4.132c1.111,1.974.24,4.767-1.681,4.767ZM3.493,7.36V5.938a5.937,5.937,0,1,1,11.874,0V7.36a5.937,5.937,0,1,1-11.874,0Z",
    transform: "translate(37 1057.639)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuUser);
export default __webpack_public_path__ + "static/media/icon-menu-user.a1f60fbdcf78cf779dcf630a8874dfdf.svg";
export { ForwardRef as ReactComponent };